import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Button, ButtonType, CloseButtonLabel } from '../atoms';
import { Dialog } from './dialog';
import { Colors } from '../styles';
import { MealAIInputImage } from './meal_ai_input_image';
export const MealAIInputAboutDialog = ({ onClickSuccess, onClickCancel }) => {
    return (React.createElement(Dialog, { onClickCancel: onClickCancel, isCloseButton: true, closeButtonLabel: CloseButtonLabel.Close, strictSameSize: true, classObject: styles.dialog, content: React.createElement("div", { className: css(styles.content) },
            React.createElement(MealAIInputImage, null),
            React.createElement("div", { className: css(styles.info) },
                React.createElement("div", { className: css(styles.title) },
                    React.createElement("div", { className: css(styles.newLabel) }, "\uFF3CNEW!\uFF0F"),
                    "AI\u304C\u3056\u3063\u304F\u308A\u5165\u529B\u3092",
                    React.createElement("br", null),
                    "\u6804\u990A\u7D20\u306B\u5909\u63DB\uFF01"),
                React.createElement("div", { className: css(styles.description) }, "\u30E1\u30CB\u30E5\u30FC\u540D\u3084\u98DF\u6750\u540D\u3092\u3056\u3063\u304F\u308A\u6253\u3064\u3060\u3051\u3067\u3001AI\u304C\u30AB\u30ED\u30EA\u30FC\u3068\u6804\u990A\u7D20\u3092\u81EA\u52D5\u8A08\u7B97\u3002\u30EA\u30B9\u30C8\u304B\u3089\u63A2\u3055\u306A\u304F\u3066\u3044\u3044\u304B\u3089\u3001\u98DF\u5F8C\u3059\u3050\u306B\u30B5\u30C3\u3068\u8A18\u9332\u3067\u304D\u307E\u3059\u3002")),
            React.createElement(Button, { className: css(styles.button), isRadius: true, buttonType: ButtonType.pink, onClick: onClickSuccess }, "\u3055\u3063\u305D\u304F\u98DF\u4E8B\u7BA1\u7406\u3059\u308B\uFF01")) }));
};
const styles = StyleSheet.create({
    dialog: {
        maxWidth: 327,
        backgroundColor: Colors.White,
        transform: 'translate(-50%, calc(-50% - 30px))',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        maxHeight: 'calc(100vh - 90px)',
        paddingBottom: 20,
        overflowX: 'hidden',
        overflowY: 'auto',
    },
    info: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        width: 290,
        height: 168,
        textAlign: 'center',
        flexShrink: 0,
    },
    title: {
        height: 80,
        fontSize: 20,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.6,
    },
    newLabel: {
        marginBottom: 4,
        color: Colors.Accent,
        fontSize: 20,
        lineHeight: 1,
    },
    description: {
        height: 80,
        fontSize: 14,
        lineHeight: '140%',
        letterSpacing: 0.56,
    },
    button: {
        width: 290,
        height: 48,
        padding: 0,
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: 1.28,
        flexShrink: 0,
    },
});
